import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { CalendarDTO, CalendarWriteDTO } from '../interfaces/calendar';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  constructor(private dataService: DataService) { }

    saveCalendar(calendarId: number, calendar: CalendarWriteDTO): Observable<CalendarDTO> {
      if (calendarId && calendarId > 0) {
        return this.dataService.updateCalendar(calendarId, calendar);
      } else {
        return this.dataService.createCalendar(calendar);
      }
    }
  
    deleteCalendar(calendar: CalendarDTO) {
      if (!calendar || calendar.id == null || calendar.id == undefined || calendar.id < 1) {
        this.dataService.deleteCalendar(calendar.id);
      }
    }
  
    getCalendars(calendarIntegrationId: number, showInDashboard: boolean): Observable<any> {
      return this.dataService.getCalendars(calendarIntegrationId, showInDashboard);
    }
  
    getCalendar(calendarId: number): Observable<any> {
      return this.dataService.getCalendar(calendarId);
    }
  
    getAllCalendars(): Observable<any> {
      return this.dataService.getAllCalendars();
    }

    getCalendarsForDashboard(): Observable<any> {
      return this.dataService.getCalendarsForDashboard();
    }

    getCalendarsForNotes(): Observable<any> {
      return this.dataService.getCalendarsForNotes();
    }

}
